module.exports = __webpack_public_path__ + "img/fund_img1.2e3768c6.jpg";